import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=dacd4386&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacd4386",
  null
  
)

component.options.__file = "Header.vue"
export default component.exports